<template>
  <div
    class="bg-white rounded-full border border-black/5 flex items-center justify-center mb-2 badge--shadow"
  >
    <Icon name="Dacr" :size="props.iconSize" />
  </div>
</template>

<script setup lang="ts">
import { Icon } from '@dacr/ui'

const props = defineProps<{
  iconSize?: number
}>()
</script>

<style scoped>
.badge--shadow {
  box-shadow: 0 4px 18px 0px rgba(0, 0, 0, 0.04);
}
</style>
